import React, { SVGProps, useId } from "react";

export const SadIcon = (props: SVGProps<SVGSVGElement>) => {
  const a = useId();
  const b = useId();
  const c = useId();
  const d = useId();
  const e = useId();
  const f = useId();
  const g = useId();
  const h = useId();
  const i = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 80 80"
      {...props}
    >
      <path
        fill={`url(#${a})`}
        d="M40.475 70.95c16.83 0 30.475-13.644 30.475-30.475C70.95 23.645 57.306 10 40.475 10 23.645 10 10 23.644 10 40.475c0 16.83 13.644 30.475 30.475 30.475Z"
      />
      <path
        fill={`url(#${b})`}
        d="M40.475 70.95c16.83 0 30.475-13.644 30.475-30.475C70.95 23.645 57.306 10 40.475 10 23.645 10 10 23.644 10 40.475c0 16.83 13.644 30.475 30.475 30.475Z"
        opacity={0.5}
      />
      <path
        fill={`url(#${c})`}
        d="M21.15 28.662c.072 1.47 1.452 2.312 3.711 2.187 1.936-.108 6.095-1.614 8.766-6.275.484-.86-.358-1.273-.86-.699-1.686 1.918-6.364 4.535-10.147 4.249-1.506-.108-1.47.538-1.47.538Z"
      />
      <path
        fill={`url(#${d})`}
        d="M30.526 41.766c1.624 0 2.94-1.983 2.94-4.428 0-2.446-1.316-4.428-2.94-4.428-1.624 0-2.94 1.982-2.94 4.428 0 2.445 1.316 4.428 2.94 4.428Z"
      />
      <path
        fill={`url(#${e})`}
        d="M30.526 34.398c1.255 0 2.366 1.093 2.94 2.725-.036-2.402-1.345-4.32-2.94-4.32-1.596 0-2.904 1.936-2.94 4.32.574-1.614 1.685-2.725 2.94-2.725Z"
      />
      <path
        fill={`url(#${f})`}
        d="M50.424 41.766c1.624 0 2.94-1.983 2.94-4.428 0-2.446-1.316-4.428-2.94-4.428-1.623 0-2.94 1.982-2.94 4.428 0 2.445 1.316 4.428 2.94 4.428Z"
      />
      <path
        fill={`url(#${g})`}
        d="M59.8 28.769c-.072 1.47-1.452 2.313-3.711 2.187-1.936-.107-6.095-1.613-8.766-6.274-.484-.86.358-1.273.86-.7 1.685 1.919 6.364 4.536 10.147 4.25 1.506-.108 1.47.537 1.47.537Z"
      />
      <path
        fill={`url(#${h})`}
        d="M50.424 34.505c-1.255 0-2.366 1.094-2.94 2.725.036-2.402 1.345-4.32 2.94-4.32 1.596 0 2.904 1.936 2.94 4.32-.573-1.613-1.685-2.724-2.94-2.724Z"
      />
      <path
        className="fill-blue-900"
        d="M40.475 51.75c8.945 0 11.796 8.839 9.07 7.458-3.656-1.864-5.969-2.026-9.07-2.026s-5.414.18-9.07 2.026c-2.726 1.38.125-7.457 9.07-7.457Z"
      />
      <path
        fill={`url(#${i})`}
        d="M40.475 53.31c5.27 0 8.605 2.976 10.057 5.45.09-1.793-3.191-7.01-10.057-7.01-6.866 0-10.146 5.217-10.057 7.01 1.452-2.456 4.787-5.45 10.057-5.45Z"
      />
      <defs>
        <radialGradient
          id={a}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="translate(34.479 28.125) scale(36.7641)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" className="stop-cyan-400" />
          <stop offset="100%" className="stop-sky-400" />
        </radialGradient>
        <radialGradient
          id={b}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="translate(34.479 28.125) scale(28.924)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" className="stop-white/20" />
          <stop offset="100%" className="stop-white/0" />
        </radialGradient>
        <linearGradient
          id={c}
          x1={27.444}
          x2={27.656}
          y1={25.871}
          y2={29.718}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.001} className="stop-blue-900" />
          <stop offset={1} className="stop-blue-800" />
        </linearGradient>
        <radialGradient
          id={d}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(73.854 -10.097 38.44) scale(4.30588 2.78584)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.001} className="stop-blue-900" />
          <stop offset={1} className="stop-blue-800" />
        </radialGradient>
        <linearGradient
          id={e}
          x1={30.525}
          x2={30.525}
          y1={32.877}
          y2={37.013}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.001} className="stop-blue-950" />
          <stop offset={1} className="stop-blue-900" />
        </linearGradient>
        <radialGradient
          id={f}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(73.854 -.147 51.68) scale(4.30588 2.78583)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.001} className="stop-blue-900" />
          <stop offset={1} className="stop-blue-800" />
        </radialGradient>
        <linearGradient
          id={g}
          x1={53.516}
          x2={53.304}
          y1={25.975}
          y2={29.822}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.001} className="stop-blue-900" />
          <stop offset={1} className="stop-blue-800" />
        </linearGradient>
        <linearGradient
          id={h}
          x1={50.425}
          x2={50.425}
          y1={32.986}
          y2={37.122}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.001} className="stop-blue-950" />
          <stop offset={1} className="stop-blue-90" />
        </linearGradient>
        <linearGradient
          id={i}
          x1={40.475}
          x2={40.475}
          y1={49.446}
          y2={56.498}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.001} className="stop-blue-950" />
          <stop offset={1} className="stop-blue-950/80" />
        </linearGradient>
      </defs>
    </svg>
  );
};
